import type { ConnectedContentInlineModel } from 'autogen/swagger/all';
import type { components } from 'autogen/swagger/all/all';

// Consolidate loading strategy based on image settings & placement in product list
export const resolveImageLoading = (
    image: components['schemas']['ResponsiveImageModel'],
    placement: ConnectedContentInlineModel['placement'] | undefined
): HTMLImageElement['loading'] | undefined => {
    // If placement is 1 or 2, or image.lazyLoad is explicitly set to false, load eagerly
    if ((placement && placement < 3) || (image.lazyLoad !== undefined && !image.lazyLoad)) return 'eager';

    // Default to lazy loading
    return 'lazy';
};

// Used with `PictureDeprecated` components, which does not support "loading" prop
// and other places where we need to return loading as a boolean
export const shouldLazyLoadImage = (
    image: components['schemas']['ResponsiveImageModel'],
    placement: ConnectedContentInlineModel['placement'] | undefined
): boolean => {
    return resolveImageLoading(image, placement) === 'lazy';
};
